import { Flex, Tooltip } from '@byecode/ui'
import { useDynamicTagDisplay } from '@lighthouse/shared'
import React from 'react'
import styled from 'styled-components'

interface OtherPlatformTagsProps {
    data: string[]
}
const SCxTag = styled.div`
    display: flex;
    padding: 0 6px;
    align-items: center;
    gap: 6px;
    line-height: 18px;
    flex-wrap: wrap;
    border-radius: 3px;
    font-size: 10px;
    color: var(--color-gray-500);
    white-space: nowrap;
    border: 1px solid var(--color-gray-200);
`
export const OtherPlatformTags: React.FunctionComponent<OtherPlatformTagsProps> = ({ data: tags }) => {
    const { containerRef, setTagRef, extraRef, displayInfo } = useDynamicTagDisplay(tags)
    const { visibleCount, extraCount } = displayInfo

    return (
        <Flex gap={6} ref={containerRef} style={{ overflow: 'hidden' }}>
            {tags?.map((tag, index) => (
                <SCxTag
                    key={tag}
                    ref={setTagRef(index)}
                    style={{
                        display: index < visibleCount ? 'flex' : 'none'
                    }}
                >
                    {tag}
                </SCxTag>
            ))}
            {extraCount > 0 && (
                <Tooltip
                    title={
                        <ul>
                            {tags?.slice(visibleCount).map(v => (
                                <li key={v}>{v}</li>
                            ))}
                        </ul>
                    }
                >
                    <SCxTag ref={extraRef}>+{extraCount}</SCxTag>
                </Tooltip>
            )}
        </Flex>
    )
}
